module.exports = __webpack_public_path__ + "img/temp_banner_promotion02.dd10ac88.png";